import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { SERVICES, TESTIDS } from "@/lib/site";
import SEO from "@/components/SEO";

export default function Services() {
  return (
    <div>
      <SEO
        title="Services"
        path="/services"
        description="Fascial Stretch Therapy, mobility assessment, personal training, mobility coaching, athletic performance training, and corporate wellness workshops in Mississauga / GTA."
      />
      <section className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 md:pt-24 pb-10">
          <p className="label-eyebrow">Services</p>
        </div>
      </section>

      <section>
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          {SERVICES.map((s, i) => (
            <div
              key={s.slug}
              data-testid={TESTIDS.services.row(s.slug)}
              className="border-b border-white/10 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-8"
            >
              <div className="md:col-span-1">
                <p className="font-display text-white/30 text-2xl font-bold">{s.number}</p>
              </div>
              <div className="md:col-span-6">
                <h2 className="font-display uppercase font-bold text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-white">
                  {s.title}
                </h2>
                <p className="mt-6 text-base md:text-lg text-zinc-300 leading-relaxed max-w-xl">
                  {s.short}
                </p>
                <p className="mt-4 text-sm text-zinc-500 max-w-xl">
                  <span className="text-zinc-400 uppercase tracking-[0.2em] text-xs font-bold mr-2">Good for:</span>
                  {s.goodFor}
                </p>
                <Link
                  to="/book"
                  className="mt-8 inline-flex items-center gap-3 border border-white/60 text-white px-6 py-3 text-xs uppercase tracking-[0.25em] font-bold hover:bg-white/10 transition-colors group"
                >
                  Enquire
                  <ArrowUpRight size={14} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                </Link>
              </div>
              <div className="md:col-span-5">
                <div className="border border-white/10 bg-[#141417] p-8">
                  <p className="label-eyebrow mb-5">What&apos;s included</p>
                  <ul className="space-y-4">
                    {s.options.map((opt) => (
                      <li key={opt} className="flex items-start gap-3">
                        <Check size={16} className="mt-1 text-white flex-shrink-0" />
                        <span className="text-white text-sm md:text-base">{opt}</span>
                      </li>
                    ))}
                  </ul>
                  <p className="mt-6 text-xs uppercase tracking-[0.2em] text-zinc-500">Custom plans available</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
